// CheckoutStepper.js
import React from 'react';
import { FormattedMessage } from 'react-intl';

const steps = ["checkout_step_cart", "checkout_step_shipping", "checkout_step_payment"];

const colors = {
    done: "#a49c89ff",
    current: "#938c7bff",
    upcoming: "#878071ff"
};

const getStepClass = (current, stepIdx) => {
    if (stepIdx < current) return "step-done";
    if (stepIdx === current) return "step-current";
    return "step-upcoming";
};

const CheckoutStepper = ({ activeStep }) => (
    <div className="checkout-stepper">
        {steps.map((label, idx) => (
            <div
                className={`step ${getStepClass(activeStep, idx)}`}
                key={label}
            >
                <span className="step-number">{idx + 1}</span>
                <span className="step-label"><FormattedMessage id={label} /></span>
            </div>
        ))}
        <style>{`
            .checkout-stepper {
                display: flex;
                justify-content: space-between;
                padding: 30px 10px 35px 10px;
                max-width: 900px;
                margin: 0 auto 15px auto;
            }
            .step {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 9px;
                min-width: 160px;
                font-size: 18px;
                font-weight: 500;
                opacity: 0.85;
            }
            .step-number {
                display: inline-flex;
                font-weight: bold;
                border-radius: 100%;
                width: 26px;
                height: 26px;
                align-items: center;
                justify-content: center;
                font-size: 18px;
                border: 2px solid #c7beaa;
                background: #fff;
                color: #c7beaa;
            }
            .step-current .step-number {
                background: #938c7bff;
                color: #fff;
            }
            .step-done .step-number {
                background: #a49c89ff;
                color: #fff;
                opacity: 0.65;
            }
            .step-upcoming .step-number {
                border: 2px solid #878071ff;
                background: #fff;
                color: #878071ff;
                opacity: 0.45;
            }
            .step-label {
                font-weight: bold;
                color: #878071ff;
            }
            .step-current .step-label {
                color: #878071ff;
            }
            .step-upcoming .step-label {
                color: #878071ff;
                opacity: 0.55;
            }
            .step-done .step-label {
                color: #878071ff;
                opacity: 0.62;
            }
            .step-label {
                text-transform: uppercase;
            }
            @media (max-width: 600px) {
                .checkout-stepper {
                    gap: 8px;
                    padding: 20px 16px;
                }
                .step {
                    min-width: 0;
                    flex: 1;
                    gap: 6px;
                    font-size: 11px;
                    line-height: 1.2;
                }
                .step-number {
                    flex-shrink: 0;
                    width: 22px;
                    height: 22px;
                    font-size: 12px;
                }
            }
        `}</style>
    </div>
);

export default CheckoutStepper;
